module.exports = __webpack_public_path__ + "img/image-03.0c429ad5.png";